<template lang="html">
  <div class="section">
    <h2 class="section-header black bgap-48" v-if="title">{{title}}</h2>
    <div v-if="loading">
      <div class="line-break-gray" />
      <div class="gap-3x" />
      <Spinner />
    </div>
    <div v-if="!loading" :class="[this.autoPadding ? 'padding-3x' : '']">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import Spinner from 'src/components/common/Spinner.vue'

export default {
  components: { Spinner },
  props: {
    title: {
      type: String
    },
    loading: {
      type: Boolean
    },
    autoPadding: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="css" scoped>
</style>
